import { ApiError } from '@cwos/api-client';
import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client. Poll cadences are set per-query (doc 06 §6.9);
 * `refetchIntervalInBackground` stays false so polling pauses when the tab is
 * hidden and resumes on focus.
 */
/**
 * Retry ONCE, and only where a second attempt can change the answer (F160).
 *
 * `retry: 1` retried everything — including 4xx. A refusal is the server's
 * decision, not a transient: the retry burned a duplicate request on EVERY
 * 403/404 in the app before the withheld state could render, which doubled
 * exactly the traffic the analyst-facing views spend the most care refusing
 * honestly. Network failures and 5xx keep their one retry; a response below
 * 500 is an answer.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (failureCount >= 1) return false;
        if (error instanceof ApiError && error.status < 500) return false;
        return true;
      },
      refetchOnWindowFocus: true,
      staleTime: 15_000,
    },
  },
});
